import { Plus } from 'lucide-react';
import React from 'react';
import { generatePath, useNavigate } from 'react-router';
import { Button } from '@/Components/shadcn';
import RoutePath from '@/Routing/RoutePath';
import UIStrings from '@/Utils/UIStrings';
import useClientIdPathParam from '@/Hooks/UseClientIdPathParam';
import useCompanyId from '@/Hooks/UseCompanyId';
import { cn } from '@/lib/utils';

interface CreateRecruitmentButtonProps {
    hideIcon?: boolean;
    hidden?: boolean;
}

const CreateRecruitmentButton = ({ hideIcon, hidden }: CreateRecruitmentButtonProps) => {
    const navigate = useNavigate();
    const companyId = useCompanyId();
    const clientId = useClientIdPathParam();

    const handleAssessmentCreateClick = () => {
        const createRecruitmentPath = generatePath(RoutePath.CreateAssessment, { companyId, clientId });
        navigate(createRecruitmentPath);
    };

    return (
        <Button
            type="button"
            onClick={handleAssessmentCreateClick}
            className={cn(hidden && 'pointer-events-none invisible')}
        >
            {!hideIcon && <Plus className="size-4" aria-hidden />}
            {UIStrings.CreateRecruitment}
        </Button>
    );
};

export default CreateRecruitmentButton;
